export enum LayoutType {
	Mobile = "Mobile",
	Desktop = "Desktop",
}
